export const MaxRetriesOptions = {
  ONE: { name: '1', id: 1 },
  // TWO: { name: '2', id: 2 },
  // THREE: { name: '3', id: 3 },
  // FOUR: { name: '4', id: 4 },
  // FIVE: { name: '5', id: 5 },
  // SIX: { name: '6', id: 6 },
  // SEVEN: { name: '7', id: 7 },
  // EIGHT: { name: '8', id: 8 },
  // NINE: { name: '9', id: 9 },
  // TEN: { name: '10', id: 10 },
};

export const ScheduleMode = {
  DELAY: 0,
  SPECIFIC_TIME: 1,
};

export const ScheduleModeOptions = [
  { id: 0, name: 'Delay' },
  { id: 1, name: 'Specific Time' },
];
